// extracted by mini-css-extract-plugin
module.exports = {"label":"FormCheckbox_label__1ljCu","large":"FormCheckbox_large__1Bh9U"};